<div class="stock-section">
  <div class="stock-list-meta" *ngIf="!loading">
    Mostrando {{ stockLines.length }} di {{ count }} righe di stock
  </div>

  <div class="stock-error" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>

  <p class="stock-loading" *ngIf="loading">
    Caricamento righe di stock...
  </p>

  <div class="stock-table-wrap" *ngIf="!loading && stockLines.length">
    <table class="stock-table">
      <thead>
        <tr>
          <th>Data</th>
          <th>Originale</th>
          <th>Rimanente</th>
          <th>Lotto</th>
          <th>Scadenza</th>
          <th>Origine</th>
          <th>Stato</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let line of stockLines">
          <td>{{ line.createdAt | date: 'short' }}</td>
          <td>{{ line.originalQuantity }}</td>
          <td>
            <strong>{{ line.remainingQuantity }}</strong>
          </td>
          <td>{{ line.batchNumber || '-' }}</td>
          <td>{{ line.expiryDate ? (line.expiryDate | date) : '-' }}</td>
          <td>{{ line.source }}</td>
          <td>
            <span
              class="status-pill"
              [class.consumed]="line.status === 'CONSUMED'"
            >
              {{ line.status }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="empty-state" *ngIf="!loading && !stockLines.length && !errorMessage">
    Nessuna riga di stock trovata con i filtri attuali.
  </div>

  <div class="stock-pagination" *ngIf="!loading && count > limit">
    <button type="button" (click)="prevPage()" [disabled]="page <= 1">
      Precedente
    </button>

    <span>
      Pagina {{ page }} di {{ totalPages }}
    </span>

    <button type="button" (click)="nextPage()" [disabled]="page >= totalPages">
      Successiva
    </button>
  </div>
</div>